import React, { useState } from "react";
import Activitebody from "./Activitebody";
import ActiviteHeader from "./ActiviteHeader";

const ActiviteListe = () => {
  const [activeView, setActiveView] = useState("");
  return (
    <section>
      <ActiviteHeader
        activeView={activeView}
        setActiveView={setActiveView}
        filter={false}
      />
      <Activitebody />
    </section>
  );
};

export default ActiviteListe;
